<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type {
    WorkOrderAssignmentContextTag,
    WorkOrderAssignmentRequesterContactMethod,
  } from "../../../contract"

  type RenderedContextTag =
    | WorkOrderAssignmentContextTag
    | WorkOrderAssignmentRequesterContactMethod

  let {
    tags = [],
  }: {
    tags?: RenderedContextTag[]
  } = $props()

  const toneColor = (tone: RenderedContextTag["tone"]) => {
    if (tone === "info") return "neutral"

    if (tone === "warning") return "amber"

    if (tone === "success") return "emerald"

    return "neutral"
  }

  const tagDetail = (tag: RenderedContextTag) => ("detail" in tag ? tag.detail : undefined)
  const detailAsSubLabel = (tag: RenderedContextTag) =>
    "detailAsSubLabel" in tag && Boolean(tag.detailAsSubLabel)
  const mainLabel = (tag: RenderedContextTag) =>
    detailAsSubLabel(tag) ? tag.label : tagDetail(tag) || tag.label
  const subLabel = (tag: RenderedContextTag) =>
    detailAsSubLabel(tag) ? tagDetail(tag) : tagDetail(tag) ? tag.label : undefined
</script>

{#if tags.length}
  <div class="context-tags">
    {#each tags as tag, index (`${tag.label}-${tagDetail(tag) ?? ""}-${index}`)}
      <StatusTag
        size="sm"
        label={mainLabel(tag)}
        subLabel={subLabel(tag)}
        color={toneColor(tag.tone)}
        icon={tag.icon}
        tooltipContent={tag.tooltipContent ?? ""}
        tooltipHtml={Boolean(tag.tooltipContent)}
        tooltipClassName={tag.tooltipContent ? RICH_TOOLTIP_CLASS : undefined}
        disableTitle={true}
      />
    {/each}
  </div>
{/if}

<style lang="less">
  .context-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    min-width: 0;
  }
</style>
